'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/8/12.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _ErrorLabel = require('../ErrorLabel/ErrorLabel');

var _ErrorLabel2 = _interopRequireDefault(_ErrorLabel);

var _reduxForm = require('redux-form');

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomItemModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'productDetailCustoms',
  fields: ['scheme', 'material', 'customs']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomItemModal, _Component);

  function CustomItemModal() {
    (0, _classCallCheck3.default)(this, CustomItemModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CustomItemModal).call(this));

    _this.state = {
      customItem: '',
      isOpened: true,
      closeHover: false,
      currentError: ''
    };
    return _this;
  }

  (0, _createClass3.default)(CustomItemModal, [{
    key: 'onCustomSchemeChosened',
    value: function onCustomSchemeChosened(scheme, material, customs, id) {
      this.setState({
        currentError: ''
      });
      var _props = this.props;
      var params = _props.params;
      var getCustomMaterial = _props.getCustomMaterial;

      material.onChange({});
      customs.onChange({});
      getCustomMaterial(params.productId, { schemeId: id });
      scheme.onChange(id);
    }
  }, {
    key: 'onCustomMaterialChosened',
    value: function onCustomMaterialChosened(scheme, material, customs, groupId, id, schemeId) {
      this.setState({
        currentError: ''
      });
      var _props2 = this.props;
      var params = _props2.params;
      var getCustomItems = _props2.getCustomItems;

      var schemeValue = scheme.value;
      if (scheme.value === '') {
        scheme.onChange(schemeId);
        schemeValue = schemeId;
      }
      customs.onChange({});
      getCustomItems(params.productId, { schemeId: schemeValue, materialId: id });
      // console.log({schemeId: scheme.value, materialId: id});
      var customValue = (0, _extends3.default)({}, material.value);
      customValue[groupId] = id;
      // console.log(customValue);
      material.onChange(customValue);
    }
  }, {
    key: 'onCustomItemChosened',
    value: function onCustomItemChosened(scheme, material, customs, groupId, id, schemeId, materialGroupId, materialId) {
      this.setState({
        currentError: ''
      });
      var isEmptyObject = this.props.isEmptyObject;
      // console.log(scheme.value);

      if (scheme.value === '') {
        scheme.onChange(schemeId);
      }
      // console.log(JSON.stringify(material));
      if (!material.value || isEmptyObject(material.value)) {
        var materialValue = {};
        materialValue[materialGroupId] = materialId;
        material.onChange(materialValue);
      }
      var customValue = (0, _extends3.default)({}, customs.value);
      customValue[groupId] = id;
      customs.onChange(customValue);
    }
  }, {
    key: 'onHandleSubmit',
    value: function onHandleSubmit(data) {
      var _props3 = this.props;
      var handleSubmit = _props3.handleSubmit;
      var _props3$fields = _props3.fields;
      var scheme = _props3$fields.scheme;
      var material = _props3$fields.material;
      var customs = _props3$fields.customs;
      var isEmptyObject = _props3.isEmptyObject;
      // console.log(scheme);
      // console.log(JSON.stringify(material));
      // console.log(JSON.stringify(customs));

      if (scheme.value === '' || !material.value || isEmptyObject(material.value) || !customs.value || isEmptyObject(customs.value)) {
        // console.log('请选择定制信息');
        this.setState({
          currentError: '请选择定制信息'
        });
      } else {
        this.setState({
          currentError: ''
        });
        handleSubmit(data);
      }
    }
  }, {
    key: 'analysisItemsData',
    value: function analysisItemsData() {
      var _this2 = this;

      var _props4 = this.props;
      var _props4$fields = _props4.fields;
      var scheme = _props4$fields.scheme;
      var material = _props4$fields.material;
      var customs = _props4$fields.customs;
      var newCustomData = _props4.newCustomData;

      var result = '';
      if (newCustomData) {
        (function () {
          var customScheme = newCustomData.customScheme;
          var customMaterial = newCustomData.customMaterial;
          var customItems = newCustomData.customItems;

          var schemeId = '';
          var materialGroupId = '';
          var materialId = '';
          if (customScheme instanceof Array && customScheme.length > 0) {
            schemeId = customScheme[0].id;
          }
          if (customMaterial instanceof Array && customMaterial.length > 0) {
            materialGroupId = customMaterial[0].groupId;
            materialId = customMaterial[0].id;
          }
          var styles = require('./CustomItemModal.scss');
          var isOpened = _this2.state.isOpened;

          var groupInfo = [];
          if (customItems instanceof Array) {
            customItems.forEach(function (singleCustom) {
              var index = groupInfo.findIndex(function (info) {
                return info.groupId === singleCustom.groupId;
              });
              if (index < 0) {
                groupInfo.push({
                  groupId: singleCustom.groupId,
                  groupName: singleCustom.groupName,
                  items: [{
                    id: singleCustom.id,
                    name: singleCustom.name,
                    price: singleCustom.price,
                    img: singleCustom.img,
                    icon: singleCustom.icon
                  }]
                });
              } else {
                groupInfo[index].items.push({
                  id: singleCustom.id,
                  name: singleCustom.name,
                  price: singleCustom.price,
                  img: singleCustom.img,
                  icon: singleCustom.icon
                });
              }
            });
          }
          result = groupInfo.map(function (info) {
            return _react2.default.createElement(
              'div',
              { key: info.groupId },
              _react2.default.createElement(
                'div',
                { className: styles.header },
                _react2.default.createElement(
                  'div',
                  { className: styles.title },
                  '选择' + info.groupName
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                _reactCollapse2.default,
                { isOpened: isOpened },
                _react2.default.createElement(
                  'ul',
                  { className: styles.xiangmuUl },
                  info.items instanceof Array ? info.items.map(function (child, index) {
                    return _react2.default.createElement(
                      'li',
                      { key: info.groupId + ',' + child.id + ',' + index },
                      _react2.default.createElement(
                        'div',
                        { style: { position: 'relative', height: '178px', width: '178px' },
                          className: customs.value && customs.value[info.groupId] === child.id ? styles.activeAll : '' },
                        _react2.default.createElement('img', {
                          onClick: function onClick() {
                            return _this2.onCustomItemChosened(scheme, material, customs, info.groupId, child.id, schemeId, materialGroupId, materialId);
                          },
                          src: child.img }),
                        customs.value && customs.value[info.groupId] === child.id ? _react2.default.createElement('span', { className: styles.spana }) : ''
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.divDe },
                        child.name + ' ￥:' + child.price
                      ),
                      _react2.default.createElement('div', { className: 'clear' })
                    );
                  }) : ''
                )
              ),
              _react2.default.createElement('div', { className: 'clear' })
            );
          });
        })();
      }
      return result;
    }
  }, {
    key: 'analysisMaterialData',
    value: function analysisMaterialData() {
      var _this3 = this;

      var _props5 = this.props;
      var _props5$fields = _props5.fields;
      var scheme = _props5$fields.scheme;
      var material = _props5$fields.material;
      var customs = _props5$fields.customs;
      var newCustomData = _props5.newCustomData;
      var isEmptyObject = _props5.isEmptyObject;

      var result = '';
      if (newCustomData) {
        (function () {
          // console.log(newCustomData);
          // console.log(material.value);
          var customScheme = newCustomData.customScheme;
          var customMaterial = newCustomData.customMaterial;

          var schemeId = '';
          if (customScheme instanceof Array && customScheme.length > 0) {
            schemeId = customScheme[0].id;
          }
          var styles = require('./CustomItemModal.scss');
          var isOpened = _this3.state.isOpened;

          var groupInfo = [];
          if (customMaterial instanceof Array) {
            customMaterial.forEach(function (singleMaterial) {
              var index = groupInfo.findIndex(function (info) {
                return info.groupId === singleMaterial.groupId;
              });
              if (index < 0) {
                groupInfo.push({
                  groupId: singleMaterial.groupId,
                  groupName: singleMaterial.groupName,
                  items: [{
                    id: singleMaterial.id,
                    name: singleMaterial.name,
                    price: singleMaterial.price,
                    img: singleMaterial.img,
                    icon: singleMaterial.icon
                  }]
                });
              } else {
                groupInfo[index].items.push({
                  id: singleMaterial.id,
                  name: singleMaterial.name,
                  price: singleMaterial.price,
                  img: singleMaterial.img,
                  icon: singleMaterial.icon
                });
              }
            });
          }
          // + ' ' + ((material.value && material.value[info.groupId] === child.id) || (( !material.value || isEmptyObject(material.value)) && index === 0 )) ? styles.activeAll : '')
          result = groupInfo.map(function (info) {
            return _react2.default.createElement(
              'div',
              { key: info.groupId },
              _react2.default.createElement(
                'div',
                { className: styles.header },
                _react2.default.createElement(
                  'div',
                  { className: styles.title },
                  '选择' + info.groupName
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                _reactCollapse2.default,
                { isOpened: isOpened },
                _react2.default.createElement(
                  'ul',
                  { className: styles.newdingpin },
                  info.items instanceof Array ? info.items.map(function (child, index) {
                    return _react2.default.createElement(
                      'li',
                      { key: info.groupId + ',' + child.id + ',' + index,
                        onClick: function onClick() {
                          return _this3.onCustomMaterialChosened(scheme, material, customs, info.groupId, child.id, schemeId);
                        } },
                      _react2.default.createElement(
                        'div',
                        {
                          className: styles.imgbox },
                        _react2.default.createElement('img', { style: { width: 174, height: 174 },
                          className: material.value && material.value[info.groupId] === child.id || (!material.value || isEmptyObject(material.value)) && index === 0 ? styles.activeAll : '',
                          src: child.img }),
                        material.value && material.value[info.groupId] === child.id || (!material.value || isEmptyObject(material.value)) && index === 0 ? _react2.default.createElement('i', { className: styles.spana }) : ''
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        child.name + ' ￥:' + child.price
                      )
                    );
                  }) : ''
                )
              ),
              _react2.default.createElement('div', { className: 'clear' })
            );
          });
        })();
      }
      return result;
    }
  }, {
    key: 'analysisCustomDetail',
    value: function analysisCustomDetail() {
      var _props6 = this.props;
      var _props6$fields = _props6.fields;
      var scheme = _props6$fields.scheme;
      var material = _props6$fields.material;
      var customs = _props6$fields.customs;
      var newCustomData = _props6.newCustomData;
      var isEmptyObject = _props6.isEmptyObject;
      // productImg

      var styles = require('./CustomItemModal.scss');
      if (newCustomData) {
        var customScheme = newCustomData.customScheme;
        var customMaterial = newCustomData.customMaterial;
        var customItems = newCustomData.customItems;

        var schemeText = '';
        //  let projectGroupName = '';
        var projectName = '';
        var projectPrice = '';
        var projectImg = '';
        var allPrice = 0;
        if (customScheme instanceof Array) {
          if (scheme.value) {
            customScheme.forEach(function (info) {
              if (scheme.value === info.id) {
                schemeText = info.name;
                if (info.price && !isNaN(parseFloat(info.price))) {
                  allPrice += parseFloat(info.price);
                }
              }
            });
          } else if (customScheme.length > 0) {
            schemeText = customScheme[0].name;
          }
        }
        // 以下部分其实有问题 目前定制项目只有一个组 如果为多个组则会显示不正确
        // 在一个组的情况下可以使用
        // console.log(isEmptyObject(material.value));
        if (customMaterial instanceof Array) {
          if (material.value && !isEmptyObject(material.value)) {
            customMaterial.forEach(function (info) {
              if (material.value[info.groupId] === info.id) {
                //  projectGroupName = info.groupName;
                projectName = info.name;
                projectPrice = info.price;
                projectImg = info.img;
                if (info.price && !isNaN(parseFloat(info.price))) {
                  allPrice += parseFloat(info.price);
                }
              }
            });
          } else if (customMaterial.length > 0) {
            // projectGroupName = customMaterial[0].groupName;
            projectName = customMaterial[0].name;
            projectPrice = customMaterial[0].price;
            projectImg = customMaterial[0].img;
            if (customMaterial[0].price && !isNaN(parseFloat(customMaterial[0].price))) {
              allPrice += parseFloat(customMaterial[0].price);
            }
          }
        }
        var bottomContainer = '';
        if (customItems instanceof Array) {
          bottomContainer = customItems.map(function (info) {
            if (customs.value && customs.value[info.groupId] === info.id) {
              if (info.price && !isNaN(parseFloat(info.price))) {
                allPrice += parseFloat(info.price);
              }
              return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.imga },
                  _react2.default.createElement('img', { src: info.img })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.nma },
                  _react2.default.createElement(
                    'p',
                    null,
                    info.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.nmaprice },
                    '¥ ',
                    info.price
                  )
                )
              );
            }
          });
        }
        var customDetailDiv = '';
        if (customScheme instanceof Array && customMaterial instanceof Array && customItems instanceof Array) {
          customDetailDiv = _react2.default.createElement(
            'div',
            { className: styles.blackbox },
            _react2.default.createElement(
              'ul',
              { className: styles.shangp },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.imga },
                  _react2.default.createElement('img', { src: projectImg })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.nma },
                  _react2.default.createElement(
                    'p',
                    null,
                    projectName
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.nmaprice },
                    '¥ ',
                    projectPrice
                  )
                )
              ),
              bottomContainer
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { style: { width: '100%', height: 1, background: '#FFFFFF', marginTop: 15 } }),
            _react2.default.createElement(
              'div',
              { className: styles.txt },
              _react2.default.createElement(
                'div',
                { className: styles.allPrice },
                '定制总额：',
                _react2.default.createElement(
                  'span',
                  { className: styles.allPriceItem },
                  '¥ '
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: styles.allPriceItem },
                  allPrice
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.tit },
                _react2.default.createElement(
                  'h3',
                  null,
                  '定制方案',
                  _react2.default.createElement(
                    'span',
                    null,
                    '：'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  schemeText
                )
              )
            )
          );
        }
        return customDetailDiv;
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var styles = require('./CustomItemModal.scss');
      // handleSubmit
      var _props7 = this.props;
      var isOpened = _props7.isOpened;
      var onClose = _props7.onClose;
      var _props7$fields = _props7.fields;
      var scheme = _props7$fields.scheme;
      var material = _props7$fields.material;
      var customs = _props7$fields.customs;
      var newCustomData = _props7.newCustomData;

      var schemeDiv = '';
      if (newCustomData) {
        var customScheme = newCustomData.customScheme;
        var customSchemeError = newCustomData.customSchemeError;

        schemeDiv = customScheme instanceof Array && customScheme.length > 0 ? customScheme.map(function (schemeInfo, index) {
          return _react2.default.createElement(
            'li',
            { key: schemeInfo.id + ',' + index,
              onClick: function onClick() {
                return _this4.onCustomSchemeChosened(scheme, material, customs, schemeInfo.id);
              } },
            _react2.default.createElement(
              'a',
              {
                className: scheme && scheme.value === schemeInfo.id || scheme.value === '' && index === 0 ? styles.active : '' },
              schemeInfo.name
            )
          );
        }) : _react2.default.createElement(
          'li',
          null,
          customSchemeError
        );
      }
      var currentError = this.state.currentError;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 10,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };

      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;

      if (closeHover) {
        hoverClassName = styles.zhuan;
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'form',
          { className: styles.component },
          _react2.default.createElement(
            'div',
            { className: styles.modalContent },
            _react2.default.createElement(
              'ul',
              { className: styles.newheader },
              schemeDiv,
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement('div', { className: styles.link })
            ),
            this.analysisMaterialData(),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.newheader },
              _react2.default.createElement(
                'h1',
                null,
                '详细定制'
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement('div', { className: styles.link })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            this.analysisItemsData(),
            this.analysisCustomDetail(),
            _react2.default.createElement('div', { style: { width: '100%', height: 20 } })
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.bottomContainer },
            _react2.default.createElement(_ErrorLabel2.default, { error: currentError || '' })
          ),
          _react2.default.createElement(_SubmitBtn2.default, { style: { marginTop: 25 }, btnClick: this.onHandleSubmit.bind(this), text: '确定' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { marginTop: 25 }, btnClick: onClose, text: '关闭' }),
          _react2.default.createElement('div', { className: 'clear' })
        )
      );
    }
  }]);
  return CustomItemModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  initialValues: _react.PropTypes.object,

  isOpened: _react.PropTypes.bool,
  onSubmit: _react.PropTypes.func,
  onClose: _react.PropTypes.func,
  newCustomData: _react.PropTypes.object,
  getCustomMaterial: _react.PropTypes.func,
  getCustomItems: _react.PropTypes.func,
  params: _react.PropTypes.object,
  productImg: _react.PropTypes.string,
  isEmptyObject: _react.PropTypes.func
}, _temp)) || _class);
exports.default = CustomItemModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomItemModal/CustomItemModal.js
 ** module id = 1322
 ** module chunks = 0
 **/